/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const ActiveResources = {
	$domTabsBlockBtn: $('.js-tabs-block__btn'),

	/** @description Initialize */
	init: function() {
		this.addResourcesHash();
	},
	/** @description Add hash for all Resources category */
	addResourcesHash: function() {
		if (this.$domTabsBlockBtn) {
			const hash = $(`.js-tabs-block__btn[data-id="${window.location.hash.substring(1)}"]`);
			hash.click();
		}
		// Trigger click event if you click on one of the Resources submenu options
		$('.js-resource-click').on('click', (e) => {
			window.location.href = window.location.origin + '/all-resources/' + e.target.hash;
			$(`.js-tabs-block__btn[data-id="${window.location.hash.substring(1)}"]`).trigger('click');
		});
		// If you are in resources-all page add hash for every resources category
		if ($('.js-tabs-block__btn.is-active')) {
			const hash = $('.js-tabs-block__btn.is-active').attr('data-id');
			window.onload = () => {
				if (window.location.pathname === '/all-resources/') {
					window.location.hash = '#' + hash;
				}
			};
			$('.js-tabs-block__btn').on('click', () => {
				window.location.hash='';
				if ($('.js-tabs-block__btn.is-active')) {
					window.location.hash = $('.js-tabs-block__btn.is-active').attr('data-id');
				}
			});
		}
	},
};

export default ActiveResources;
